import problemsJson from "./data/problems-data.json";

export type UrgencyLevel = "cosmetic" | "fix_soon" | "urgent";

export interface HomeProblem {
  slug: string;
  title: string;
  description: string;
  causes: string[];
  urgency_level: UrgencyLevel;
  recommended_trade_category: string;
  what_the_fix_involves: string;
  prevention_tips: string;
  related_problem_slugs: string[];
}

export const PROBLEMS_DATA = problemsJson as HomeProblem[];

export function getProblemBySlug(slug: string): HomeProblem | undefined {
  return PROBLEMS_DATA.find((p) => p.slug === slug);
}

export function getProblemsByTrade(tradeSlug: string): HomeProblem[] {
  return PROBLEMS_DATA.filter(
    (p) => p.recommended_trade_category === tradeSlug
  );
}

export function getAllProblemSlugs(): string[] {
  return PROBLEMS_DATA.map((p) => p.slug);
}
